<div class="max-w-md mx-auto lg:max-w-4xl lg:px-0 lg:mx-auto">
  <div
    class="px-5 lg:px-0 max-w-md mx-auto lg:max-w-full pb-4 lg:pb-6"
    *ngIf="heading || leading"
  >
    <h2
      *ngIf="heading"
      class="font-accent font-bold text-2xl lg:text-3xl text-neutral-800"
    >
      {{ heading }}
    </h2>
    <p
      *ngIf="leading"
      class="mt-1 text-sm md:text-base font-base text-neutral-600"
    >
      {{ leading }}
    </p>
  </div>
  <ul
    *ngIf="isMobile"
    class="flex overflow-x-auto scrollbar-hide pb-8 lg:pb-12 px-5 lg:px-0"
  >
    <li
      class="ml-1 mr-3 min-w-10 w-10 lg:min-w-52 lg:w-52 flex-shrink-0 flex-grow-0"
      *ngFor="let suggestion of suggestions"
    >
      <app-product-card-atom
        *ngIf="suggestion.type === 'product'"
        displayContext="suggestion"
        [product]="suggestion.data"
        (productClick)="productClick(suggestion.data)"
      ></app-product-card-atom>
    </li>
  </ul>
  <div
    class="px-5"
    *ngIf="!isMobile"
  >
    <app-card-carousel
      [cards]="suggestions"
      [nbDisplayCards]="2"
      [carouselItem]="productTemplate"
    ></app-card-carousel>
    <ng-template
      #productTemplate
      let-suggestion
    >
      <div class="flex-1 items-stretch">
        <app-product-card-atom
          *ngIf="suggestion.type === 'product'"
          displayContext="suggestion"
          [product]="suggestion.data"
          (productClick)="productClick(suggestion.data)"
        ></app-product-card-atom>
      </div>
    </ng-template>
  </div>
</div>
